import { HomeData } from '@practium/features/home';

export const consultantHomeMockData: HomeData = {
	user: {
		name: 'Maria',
		type: 'Consultor',
		plan: 'Business',
	},

	carousel: [
		{
			id: '1',
			title: 'Conheça nosso treinamento completo para cadeia produtiva do café.',
			buttonText: 'Saber mais',
			buttonLink: '/saber-mais',
			imageUrl: '/images/carousel-slide-1.jpg',
		},
		{
			id: '2',
			title: 'Visualize as análises de solo pendentes dos seus agricultores',
			buttonText: 'Ver Análises',
			buttonLink: '/analises/pendentes',
			imageUrl: '/images/carousel-slide-2.jpg',
		},
		{
			id: '3',
			title: 'Cadastre novos agricultores e mapeie suas propriedades',
			buttonText: 'Vincular Agricultor',
			buttonLink: '/usuarios/novo',
			imageUrl: '/images/carousel-slide-3.jpg',
		},
	],

	actionCards: [
		{
			id: 'flora-ai',
			title: 'Flora AI',
			subtitle: 'Tem alguma dúvida? Converse com a Flora, nossa IA especialista',
			buttonText: 'Falar agora',
			buttonLink: '/flora-ai',
			variant: 'flora',
		},
		{
			id: 'carteira',
			title: 'Minha Carteira',
			subtitle: 'Acesse rapidamente as propriedades dos seus clientes vinculados',
			buttonText: 'Ver Agricultores',
			buttonLink: '/usuarios',
			variant: 'applications',
		},
		{
			id: 'dashboard',
			title: 'Dashboard',
			subtitle: 'Não consegue visualizar? Veja agora a evolução da sua operação',
			buttonText: 'Ver agora',
			buttonLink: '/dashboard',
			variant: 'dashboard',
		},
	],

	calendar: {
		currentMonth: 'Janeiro',
		currentYear: 2026,
		events: [
			{
				id: '1',
				title: 'Visita Técnica - Fazenda São José',
				description: 'Coleta de solo para análise de rotina',
				date: '2026-01-12',
				type: 'visita',
				icon: '🚗',
				color: 'var(--primary)',
			},
			{
				id: '2',
				title: 'Entrega de Recomendação',
				description: 'Apresentação do plano de adubação - Sítio Boa Vista',
				date: '2026-01-14',
				type: 'reuniao',
				icon: '📋',
				color: 'var(--primary)',
			},
			{
				id: '3',
				title: 'Monitoramento de Pragas',
				description: 'Fazenda Esperança - Talhão 03',
				date: '2026-01-18',
				type: 'campo',
				icon: '🐛',
				color: 'var(--primary)',
			},
			{
				id: '4',
				title: 'Revisão de Laudos',
				description: 'Processar análises recebidas do laboratório',
				date: '2026-01-22',
				type: 'escritorio',
				icon: '💻',
				color: 'var(--primary)',
			},
			{
				id: '5',
				title: 'Visita de Acompanhamento',
				description: 'Verificação da aplicação de corretivos - Sr. Pedro',
				date: '2026-01-26',
				type: 'visita',
				icon: '🚗',
				color: 'var(--primary)',
			},
		],
		selectedPeriod: {
			start: '2026-01-12',
			end: '2026-01-26',
		},
	},

	history: [
		{
			id: '1',
			action: 'Recomendação de fertilização gerada',
			department: 'Técnico',
			date: '10/05/2026',
			status: 'Em breve',
			createdAt: '2026-05-10T14:30:00Z',
		},
		{
			id: '2',
			action: 'Novo agricultor vinculado',
			department: 'Carteira',
			date: '08/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-08T09:15:00Z',
		},
		{
			id: '3',
			action: 'Análise de solo importada',
			department: 'Laboratório',
			date: '07/05/2026',
			status: 'Em breve',
			createdAt: '2026-05-07T11:00:00Z',
		},
		{
			id: '4',
			action: 'Visita técnica registrada',
			department: 'Campo',
			date: '05/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-05T16:20:00Z',
		},
		{
			id: '5',
			action: 'Ticket de suporte aberto',
			department: 'Suporte',
			date: '08/05/2026',
			status: 'Em breve',
			createdAt: '2026-05-08T15:30:00Z',
		},
		{
			id: '6',
			action: 'Nova área "Pomar Novo" criada',
			department: 'Propriedades',
			date: '06/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-06T09:45:00Z',
		},
		{
			id: '7',
			action: 'Recomendação visualizada',
			department: 'Recomendações',
			date: '05/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-05T14:20:00Z',
		},
	],

	planInfo: {
		name: 'Business',
		expirationDate: '15/10/26',
		upgradeMessage: 'Aumente o limite de agricultores vinculados fazendo um upgrade!',
	},
};
